import { render, staticRenderFns } from "./CdbCustomerRelationship.vue?vue&type=template&id=1a066a4c&scoped=true&"
import script from "./CdbCustomerRelationship.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerRelationship.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerRelationship.vue?vue&type=style&index=0&id=1a066a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a066a4c",
  null
  
)

export default component.exports